import styled from 'styled-components';

const Logo = styled.img`
  margin-left: 0;
  height: 70px;
  cursor: pointer;
`;

export default Logo;
